import { Controller } from "@hotwired/stimulus"

// The landing's walkthrough film. The page carries only a poster and the
// chapter list; the <video> (served from the CDN) is created on the first
// click, so no video bytes load before anyone asks. A chapter button starts
// the film at its chapter, and the chapter being watched is marked.
export default class extends Controller {
  static targets = ["stage", "chapter"]
  static values = { src: String, label: String }

  play() {
    this.start(0)
  }

  seek(event) {
    this.start(Number(event.params.start) || 0)
    if (this.stageTarget.getBoundingClientRect().top < 0) this.stageTarget.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  start(seconds) {
    const video = this.video || this.mount()
    const go = () => {
      video.currentTime = seconds
      video.play().catch(() => {})
    }
    if (video.readyState >= 1) go()
    else video.addEventListener("loadedmetadata", go, { once: true })
    this.mark(seconds)
  }

  mount() {
    const video = document.createElement("video")
    video.src = this.srcValue
    video.controls = true
    video.playsInline = true
    video.preload = "metadata"
    video.className = "absolute inset-0 w-full h-full bg-black"
    video.setAttribute("aria-label", this.labelValue)
    video.addEventListener("timeupdate", () => this.mark(video.currentTime))
    this.stageTarget.replaceChildren(video)
    this.video = video
    return video
  }

  // The last chapter that has started by `seconds`.
  mark(seconds) {
    let current = null
    for (const chapter of this.chapterTargets) {
      if (Number(chapter.dataset.walkthroughStartParam) <= seconds + 0.5) current = chapter
    }
    for (const chapter of this.chapterTargets) {
      if (chapter === current) chapter.setAttribute("aria-current", "true")
      else chapter.removeAttribute("aria-current")
    }
  }
}
